<div class="card"><GenericError message="Your session has expired. Please login again." buttonText="Sign in" :buttonFunction="goToLogin"></GenericError></div>